<template>
  <Card variant="cockpit">
    <Flex justify-between items-center gap-3 class="flex-wrap sm:flex-nowrap">
      <FlexCol justify-center gap-1 class="min-w-0 grow">
        <p class="text-[10px] font-semibold uppercase tracking-[0.2em] text-cockpit-green">Work Cockpit // Operação</p>
        <h1 class="font-semibold text-2xl text-cockpit-text" :class="{ 'border-b border-cockpit-line pb-1': breadcrumb }">
          <IconSolid :icon="props.icon" class="mr-2 text-4xl" v-if="props.icon" />
          <span class="font-montserrat-700">{{ props.title }}</span>
        </h1>
        <Breadcrumb v-if="breadcrumb" />
      </FlexCol>
      <Flex justify-end gap-3 items-center class="shrink-0 flex-nowrap">
        <slot></slot>
      </Flex>
    </Flex>
  </Card>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: String,
  icon: String,
  breadcrumb: {
    type: Boolean,
    default: false,
  },
})
</script>
